(function ($) {
    $(document).ready(function () {
        initializeSliders();

        $(document).on('ajaxComplete', function () {
            initializeSliders();
        });

        function initializeSliders() {
            if (window.innerWidth <= 991.98) {
                $('.single-sliders').each(function () {
                    if ($(this).hasClass('swiper-initialized')) {
                        console.log('Slider already initialized:', this.id);
                        return;
                    }

                    let sliderId = $(this).attr('id');
                    let swiperContainer = `#${sliderId}`;

                    // Добавляем необходимую структуру для Swiper
                    $(this).addClass('swiper')
                        .append('<div class="swiper-wrapper"></div>') // Добавляем только wrapper
                        .after('<div class="swiper-pagination"></div>'); // Пагинация добавляется после слайдера

                    $(this).children(':not(.swiper-wrapper)').each(function () {
                        $(this).addClass('swiper-slide').appendTo(`${swiperContainer} .swiper-wrapper`);
                    });

                    // Инициализация Swiper
                    new Swiper(swiperContainer, {
                        slidesPerView: 1,
                        spaceBetween: 30,
                        navigation: {
                            nextEl: '.swiper-button-next',
                            prevEl: '.swiper-button-prev',
                        },
                        pagination: {
                            el: `${swiperContainer} ~ .swiper-pagination`, // Указываем пагинацию, находящуюся после контейнера
                            clickable: true,
                        },
                        autoHeight: true,
                        breakpoints: {
                            0: {
                                slidesPerView: 1,
                            },
                            600: {
                                slidesPerView: 2,
                            },
                        },
                    });

                    $(this).addClass('swiper-initialized');
                });
            }
        }

        const swiper = new Swiper('#heroSwiper', {
            loop: false,
            slidesPerView: 1,
            spaceBetween: 200,
            parallax: false,
            pagination: {
                el: '.hero-swiper-pagination',
                type: 'bullets',
                clickable: true,
            },
            autoplay: false,
        });

    });
})(jQuery);
